import { Box } from '@chakra-ui/react';
import { ChakraProvider } from '@chakra-ui/react';
import theme from '../src/global/theme';
function App({ children }: React.PropsWithChildren<{}>) {
    return <ChakraProvider theme={theme}>{children}</ChakraProvider>;
}

export default App;
